import React, { ReactNode } from 'react';
import { DrefNode } from './utils/rich-parser';
import { resolveCustomComponent } from './registry';

interface Props {
  children: ReactNode[];
  node: DrefNode;
  richTextProps: any;
}

function checkChildren(children: ReactNode) {
  if (children) {
    if (Array.isArray(children) && children.length === 0) {
      return false;
    }
    return true;
  }
  return false;
}

export default function Dref({ children, node, richTextProps }: Props) {
  const hasChildren = checkChildren(children);

  const { component: CustomComponent, isBlock } = resolveCustomComponent(node.attributes, hasChildren) || {};

  if (CustomComponent) {
    if (isBlock && children) {
      return (
        <CustomComponent {...node.attributes} richTextProps={richTextProps} node={node}>
          {children}
        </CustomComponent>
      );
    }
    return <CustomComponent {...node.attributes} richTextProps={richTextProps} node={node} />;
  }

  return null;
}
